// extracted by mini-css-extract-plugin
export var locationCard = "_eg-0";